<template>
    <div>
        <v-layout row align-center justify-space-between class="header report-header">
            <v-btn flat dark :to="'/bot/' + activeBot.code" class="report-back-btn">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">{{$t('settings')|capitalize}}</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                    v-for="bot in botList"
                                    :key="bot.code"
                                    @click="changeBot(bot)"
                                    :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-layout row wrap>
            <v-flex md12 lg6>
                <v-layout row wrap>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                        <CustomInfo :botCode="activeBot.code"></CustomInfo>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                        <CRMAttributeConfig :botCode="activeBot.code"></CRMAttributeConfig>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                        <NotifySetting :botCode="activeBot.code"></NotifySetting>
                    </v-flex>
                    <v-flex xs12 lg12>
                        <ShowLastAgentMessageConfig :botCode="activeBot.code"></ShowLastAgentMessageConfig>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                        <CustomerInfoSetting :botCode="activeBot.code"></CustomerInfoSetting>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                        <AutoMadConfig :botCode="activeBot.code"></AutoMadConfig>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasAdminRole && botConfig['enableBulkMad'] === '1'">
                        <BulkMAD :botCode="activeBot.code"></BulkMAD>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex md12 lg6>
                <v-layout row wrap>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                        <AutoAssignConfig :botCode="activeBot.code"></AutoAssignConfig>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                      <AgentQuickResponse :bot-code="activeBot.code"></AgentQuickResponse>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                      <RatingConfig :botCode="activeBot.code"></RatingConfig>
                    </v-flex>
                    <v-flex xs12 lg12 v-if="hasManageRole">
                      <SLAConfig :botCode="activeBot.code"></SLAConfig>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <default-dialog></default-dialog>
        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import {mapActions, mapMutations, mapState} from "vuex";
import CustomInfo from "@/views/settings/CustomInfo";
import AutoAssignConfig from "@/views/settings/AutoAssignConfig";
import CRMAttributeConfig from "@/views/settings/CRMAttributeConfig";
import NotifySetting from "@/views/settings/NotifySetting";
import ShowLastAgentMessageConfig from "@/views/settings/ShowLastAgentMessageConfig"
import CustomerInfoSetting from "@/views/settings/CustomerInfoSetting";
import AutoMadConfig from "@/views/settings/AutoMadConfig";
import BulkMAD from "@/views/settings/BulkMAD";
import StaffService from "@/services/staff.service";
import AgentQuickResponse from "@/views/settings/AgentQuickResponse";
import ActionTypes from "@/store/ActionTypes";
import RatingConfig from "@/views/settings/RatingConfig";
import SLAConfig from '@/views/settings/SLAConfig.vue';

export default {
        name: 'Settings',
        components: {
            CustomInfo, AutoAssignConfig, CRMAttributeConfig, NotifySetting, ShowLastAgentMessageConfig, CustomerInfoSetting, AutoMadConfig,
            BulkMAD, AgentQuickResponse, RatingConfig, SLAConfig,
          DefaultDialog: ()=> import(
              "../../components/dialog/Index"
              )
        },
        data() {
            return {
                activeBot: {},
                loadingDialog: false,
                botList: [],
                hasManageRole: false,
                hasAdminRole: false,
            }
        },
        computed: {
            ...mapState(['user', 'token', 'bot', 'botStaffList']),
            ...mapState('config', ['botConfig']),
        },
        mounted() {
            this.loadingDialog = true;
            if (this.botStaffList.length > 0) {
                this.botList = _.map(this.botStaffList, o => {
                    return {name: o.bot_name, code: o.bot_code}
                });
                this.initActiveBot();
                this.checkRole()
            }
            else {
                this.initBotStaffList();
            }
            this.getAllCustomerAttributes();
        },
        methods: {
            ...mapMutations('config', ['setBotConfig']),
            ...mapActions('crm', ['getAllCustomerAttributes']),
            changeBot(bot) {
                this.$store.commit(ActionTypes.BOT, bot)
                this.$router.push('/settings/' + bot.code)
            },
            selectBot(bot) {
                this.activeBot = bot;
            },
            checkRole() {
                this.hasAdminRole = StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9])
                return this.hasManageRole = StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5])
            },
            initActiveBot() {
                let botCode = this.$route.params.botCode;
                if (botCode) {
                    let bot = _.find(this.botStaffList, o => o.bot_code === botCode);
                    this.selectBot({code: bot.bot_code, name: bot.bot_name});
                } else if (this.botList.length > 0) {
                    this.selectBot(this.botStaffList[0])
                } else {
                    this.loadingDialog = false
                }
                this.loadingDialog = false
            },
            initBotStaffList() {
                if(this.botStaffList.length < 1) {
                    this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
                }
            },
        },
        watch: {
            '$route'() {
                let botCode = this.$route.params.botCode
                if (botCode) {
                    let bot = _.find(this.botList, bot => bot.code === botCode)
                    if (bot) {
                        this.selectBot(bot)
                        this.getAllCustomerAttributes();
                    }
                }
                this.checkRole()
            },
            botStaffList () {
                this.botList = _.map(this.botStaffList, o => {
                    return {name: o.bot_name, code: o.bot_code}
                });
                this.initActiveBot();
                this.checkRole();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }

    ::v-deep .v-card__title {
        height: 40px;
        background: #0052CC 0% 0% no-repeat padding-box;
        padding: 8px 12px !important;
    }

    ::v-deep .v-card {
        border-radius: 4px !important;
    }

    ::v-deep .headline {
        color: #FFFFFF;
        font-size: 18px !important;
        line-height: 30px;
    }

    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }

    .header-tooltips {
        width: 240px;
        background: #1b3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2a4b64;
        }
    }

    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00afc8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }

    .add-custom-info {
        color: #FFFFFF;
        text-transform: none;
        font-weight: bold;
        border-radius: 5px !important;
        margin-left: 0px !important;
    }
</style>
